/**
 * @usable/office-shell — the shared React shell + bootstrap() entry for Office
 * add-ins, including the local chat-history UI (HistoryPanel + DevInspector).
 *
 * The companion `taskpane.html` / `commands.html` ship as templates and the
 * ribbon handler is exported at `@usable/office-shell/commands`.
 */

export { bootstrap } from "./bootstrap";
export { App } from "./App";
export type { AppConfig } from "./App";

export { HistoryPanel } from "./components/HistoryPanel";
export { DevInspector, readInspectorOpen, persistInspectorOpen } from "./components/DevInspector";
export { pushDebugLog, getDebugLogs, clearDebugLogs, subscribeDebugLog } from "./debug-log";
export type { DebugLogEntry } from "./debug-log";
